import { ToastType } from 'react-native-toast-notifications';

export const rootToaster: { current: ToastType | null } = { current: null };
// modals require a separate toaster to show up in the modal
export const modalToaster: { current: ToastType | null } = { current: null };
